module.exports = __webpack_public_path__ + "img/segurify_logo_bco.7f070ff2.png";